module.exports = __webpack_public_path__ + "static/media/PaulErnster.52a13f53.jpg";